import { render, staticRenderFns } from "./ReportMinigame.vue?vue&type=template&id=12731895"
import script from "./ReportMinigame.vue?vue&type=script&lang=js"
export * from "./ReportMinigame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports